import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ManagePaymentsListInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.requestHandler(request));
  }

  requestHandler(request: HttpRequest<any>): HttpRequest<any> {
    const statusList = ['ENTERED', 'PROCESSED', 'ACCEPTED', 'REJECTED', 'CANCELLATION_PENDING', 'CANCELLED', 'READY'];
    const requestStatus = request.params.getAll('status');
    const requestStatusList = requestStatus?.length ? requestStatus : statusList;
    // const filteredStatus = requestStatusList.filter((status: string): boolean => status !== 'READY');

    let params = new HttpParams();

    params = params.append('paymentTypeGroup', 'DEBIT');

    params = request.params?.keys().reduce((acc: HttpParams, key: string): HttpParams => {
      acc = acc.append(key, request?.params?.get(key) || '');
      return acc;
    }, params);

    params = requestStatusList.reduce((acc: HttpParams, status: string): HttpParams => {
      const currentStatuses = acc.getAll('status') || [];

      if (currentStatuses.indexOf(status) < 0) {
        acc = acc.append('status', status)
      }

      return acc;
    }, params);

    if (request.url.indexOf('payment-order-service/client-api/v2/payment-orders') > -1 && request.method === 'GET') {
      return request.clone({ params });
    }
    return request;
  }
}
